import { Injectable } from '@angular/core';
import { CallableNames, DbService } from '../../db.service';
import { Observable } from 'rxjs';

export interface IClosedLecturerAttendanceMonthToggleData {
  month?: number;
  year?: number;
  organizationId: number;
  state: 'ON' | 'OFF';
}
export interface IClosedLecturerAttendanceMonthIsClosedData {
  month?: number;
  year?: number;
  organizationId: number;
}


@Injectable({
  providedIn: 'root'
})
export class ClosedLecturerAttendanceMonthsService {

  constructor(
    private dbService: DbService
  ) { }

  public isMonthClosed(data: IClosedLecturerAttendanceMonthIsClosedData): Observable<boolean> {
    const obs = this.dbService.runCallable({ name: CallableNames.callablesclosedLecturerAttendanceMonthIsClosed, data });
    return this.dbService.handleObs(obs, { succSilent: true });
  }
  
  public toggle(data: IClosedLecturerAttendanceMonthToggleData) {
    const obs = this.dbService.runCallable({ name: CallableNames.callablesClosedLecturerAttendanceMonthToggle, data });
    return this.dbService.handleObs(obs);
  }
}
